import request from '@/utils/request'

// 登录
export function login(params) {	
	return request({
		url: '/login/doLogin',
		method: 'post',
		data:params,
	})
}

/**
 * 注册
 * @param {*} params 
 * @returns 
 */
export function register(params){
	return request({
		url: '/login/doRegister',
		method: 'post',
		data:params,
	})
}

/**
 * 获取登录的用户信息
 * @param {*} params 
 * @returns 
 */
export function getInfo(params){
	return request({
		url: '/login/getInfo',
		method: 'post',
		data:params,
	})
}

/**
 * 获取验证码
 * @returns 
 */
export function getKaptcha() {
	return request({
	  url: '/captchaImage',
	  method: 'get'
	})
}
/**
 * 获取路由信息
 * @returns 
 */
export function getRouters(){
	return request({
		url: '/login/getRouters',
		method: 'post'
	})
}
export function logout(){
	return request({
		url: '/login/logout',
		method: 'post'
	})
}